import useSWR from "swr";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface PremiumIndexState {
  storeData: any;
  update: (symbol: string, data: any) => void;
}

const useChartPrice = create<PremiumIndexState>()(
  persist(
    (set) => ({
      storeData: {},
      update: (symbol, data) => {
        set((state) => {
          state.storeData[symbol] = data;
          return state;
        });
      },
    }),
    {
      name: "chart-index-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useChartData = (symbol) => {
  const storeData = useChartPrice((state) => state.storeData);
  const update = useChartPrice((state) => state.update);

  // Clean symbol: remove slashes and ensure uppercase
  const cleanSymbol = symbol?.replace('/', '').toUpperCase() || 'BTCUSDT';

  const { mutate } = useSWR("@BINANCE/indexPriceKlines/" + cleanSymbol, async () => {
    try {
      const response = await fetch(
        `https://www.binance.com/fapi/v1/indexPriceKlines?pair=${cleanSymbol}&interval=12h&limit=50`
      );
      let data = await response.json();

      // Check if data is valid array
      if (!Array.isArray(data)) {
        return [];
      }

      //[[1706788800000,"42085.16021277","43272.25382979","41946.31872340","43082.56090909","0",1706831999999,"0",43200,"0","0","0"]]
      //5번째값만 (close price)
      data = data.map((d) => +d?.[4] || 0);

      if (data && data.length > 0) {
        update(cleanSymbol, data);
      }

      return data;
    } catch (error) {
      console.error('Chart data fetch error:', error);
      return [];
    }
  }, {
    revalidateOnFocus: false,
    dedupingInterval: 60000,
  });

  return {
    data: storeData[cleanSymbol] || [],
    mutate,
  };
};
